import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Our components
import Notification from '../../../pages/General/Notification'
import NorowsData from '../../../pages/General/NorowsData'
import KitDetailsForm from '../../../pages/General/KitDetailsForm'


// mui components
import {
    FormControl,
    Pagination,
    IconButton,
    Button,
    Tooltip,
    Box,
    TextField,
    Modal,
    Autocomplete,
    MenuItem,
    styled,
    Tabs,
    Tab,
    Typography,
    Select,
    InputLabel,
    Grid,
    Stack
} from "@mui/material";
import LinearProgress from '@mui/material/LinearProgress';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';
import EditIcon from '@mui/icons-material/Edit';
import UploadIcon from '@mui/icons-material/Upload';
import CloseIcon from '@mui/icons-material/Close';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import Chip from "@mui/material/Chip";
import { CircularProgress } from '@mui/material';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import {
    DataGrid,
    GridToolbarContainer,
    GridFooterContainer,
    // DataGridPro
} from '@mui/x-data-grid';

import { fetchLineItemsData, importProducts, fetchNewLineItemsData, updateLineItems,
     destoryLineitems, storeNewProduct, resetLineItemSettingsState, fetchKitLineItemsData,fetchSkuINfo } from './lineitemSettingsSlice';
import { fetchCountry } from '../../../pages/General/countryStateCitySlice';
// import Filters from './Filters'
const Input = styled('input')({
    display: 'none',
});
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper'
};
const deleteModalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
};
// Re-architected modal overlay container style specs matching modern layouts
const enterpriseImportModalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '95%', sm: 620 }, // Smooth adaptation onto compressed dashboard viewpoints
    outline: 'none',
    border: 'none',
    boxSizing: 'border-box'
};
// Re-architected modal box framework specs matching production dashboard layouts
const enterpriseDeleteModalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: 420 }, // Seamless architectural workflow scaling onto layout screens
    backgroundColor: '#FFFFFF',
    borderRadius: '16px',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    border: '1px solid #E2E8F0',
    p: 3.5,
    outline: 'none',
    overflow: 'hidden'
};
// Shared enterprise style object matching production form configurations
const enterpriseModalInputStyles = {
    width: '100%',
    '& .MuiOutlinedInput-root': {
        borderRadius: '10px',
        backgroundColor: '#FFFFFF',
        transition: 'all 0.2s ease-in-out',
        border: '1px solid #E2E8F0',
        '& fieldset': { border: 'none' },
        '&:hover': {
            borderColor: '#CBD5E1',
            boxShadow: '0 2px 8px rgba(0,0,0,0.02)'
        },
        '&.Mui-focused': {
            borderColor: '#1976d2', // --- CORPORATE BLUE BRAND ACCENT MATRIX ---
            boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.08)'
        }
    },
    '& .MuiFilledInput-root': {
        borderRadius: '10px',
        backgroundColor: '#F1F5F9',
        border: '1px solid #E2E8F0',
        '&::before, &::after': { display: 'none' },
        '&:hover': { backgroundColor: '#E2E8F0' }
    },
    '& .MuiInputLabel-root': {
        color: '#64748B',
        fontWeight: 500,
        transform: 'translate(14px, 10px) scale(1)',
        '&.Mui-focused, &.MuiInputLabel-shrink': {
            transform: 'translate(14px, -8px) scale(0.75)',
            color: '#1976d2',
            fontWeight: 600
        }
    },
    '& .MuiSelect-select, & input': {
        padding: '10px 14px !important',
        fontSize: '13.5px',
        color: '#1E293B',
        fontWeight: 500
    },
    '& .MuiFormHelperText-root': {
        mx: 0.5,
        mt: 0.75,
        fontWeight: 500
    }
};

const enterpriseModalWrapperStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '95%', sm: 720, md: 850 }, // Responsive breakdown widths for optimal content scanning
    outline: 'none',
    border: 'none',
    boxSizing: 'border-box'
};
// Reusable structural style layout dictionary matching enterprise form controls
const enterpriseControlStyles = {
    '& .MuiOutlinedInput-root': {
        borderRadius: '10px',
        backgroundColor: '#FFFFFF',
        transition: 'all 0.2s ease-in-out',
        border: '1px solid #E2E8F0',
        '& fieldset': { border: 'none' },
        '&:hover': { borderColor: '#CBD5E1' },
        '&.Mui-focused': {
            borderColor: '#1976d2',
            boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.08)'
        }
    },
    '& .MuiInputLabel-root': {
        color: '#64748B',
        fontWeight: 600,
        transform: 'translate(14px, 8px) scale(1)',
        '&.Mui-focused, &.MuiInputLabel-shrink': {
            transform: 'translate(14px, -8px) scale(0.75)',
            color: '#1976d2'
        }
    },
    '& .MuiSelect-select, & input': {
        padding: '8px 14px !important',
        fontSize: '13px',
        color: '#1E293B',
        fontWeight: 500
    }
};
// 1. Dynamic Shared Toolbar Component Factory Matrix
function SharedToolbarFactory({ activeMeta, dataLength, totalCount, onPerPageChange }) {
    return (
        <GridToolbarContainer
            sx={{
                p: 2,
                bgcolor: '#F8FAFC',
                borderBottom: '1px solid #E2E8F0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: 2,
                width: '100%',
                boxSizing: 'border-box'
            }}
        >
            {/* Dynamic Pagesize Select Menu Option Component */}
            <Stack direction="row" spacing={1} alignItems="center">
                <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#64748B' }}>Show</Typography>
                <FormControl size="small" variant="outlined" sx={{ minWidth: 75, ...enterpriseControlStyles }}>
                    <Select value={activeMeta?.per_page || 10} onChange={onPerPageChange}>
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={20}>20</MenuItem>
                        <MenuItem value={50}>50</MenuItem>
                        <MenuItem value={100}>100</MenuItem>
                    </Select>
                </FormControl>
                <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#64748B' }}>entries</Typography>
            </Stack>

            {/* Dynamic Realtime Dataset Row Status Badges Container */}
            <Box sx={{ display: 'inline-flex', py: 0.5, px: 1.2, borderRadius: '6px', backgroundColor: '#E2E8F0', border: '1px solid #CBD5E1' }}>
                <Typography variant="body2" sx={{ fontSize: '12px', fontWeight: 600, color: '#475569' }}>
                    Showing <strong style={{ color: '#0F172A' }}>{dataLength || 0}</strong> of <strong style={{ color: '#0F172A' }}>{totalCount || 0}</strong>
                </Typography>
            </Box>
        </GridToolbarContainer>
    );
}

// 2. Dynamic Shared Pagination Component Factory Matrix
function SharedPaginationFactory({ targetMeta, targetCallback }) {
    return (
        <GridFooterContainer
            sx={{
                p: 1.5,
                bgcolor: '#F8FAFC',
                borderTop: '1px solid #E2E8F0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                width: '100%',
                boxSizing: 'border-box',
                '& .MuiPaginationItem-root': {
                    fontSize: '12.5px',
                    fontWeight: 600,
                    borderRadius: '8px',
                    '&.Mui-selected': {
                        backgroundColor: '#1976d2',
                        color: '#FFFFFF',
                        '&:hover': { backgroundColor: '#115293' }
                    }
                }
            }}
        >
            <Pagination
                color="primary"
                shape="circular"
                page={targetMeta?.current_page || 1}
                count={targetMeta?.last_page || 1}
                onChange={targetCallback}
            />
        </GridFooterContainer>
    );
}
const ProductLineItemsPage = () => {
    const dispatch = useDispatch();
    const lineitemsettings = useSelector(state => state.lineitemsettings.orderLineItemData);
    const newlineitemsettings = useSelector(state => state.lineitemsettings.NewrOrderLineItemData);
    const kitlineitemsettings = useSelector(state => state.lineitemsettings.kitOrderLineItemData);
    const importproduct = useSelector(state => state.lineitemsettings.importproducts);
    const lineitemsnotify = useSelector(state => state.lineitemsettings.lineitemsnotify);
    const country_code = useSelector(state => state.countrystate.country);
    const filteredCountryData = country_code.data.filter(({ code }) => code);
    const profile = useSelector(state => state.auth.profile);
    const skuInfos = useSelector(state => state.lineitemsettings.skuINfo);
    const [meta, setMeta] = useState(lineitemsettings.meta);
    const [newMeta, setNewMeta] = useState(newlineitemsettings.newMeta);
    const [kitMeta, setKitMeta] = useState(kitlineitemsettings.kitMeta);
    const [selectedItem, setSelectedItem] = useState({});
    const [modalVisible, setModalVisible] = useState(false);
    const [originCountryCode, setOriginCountryCode] = useState("");
    const [hsTariffcode, setHsTariffcode] = useState("");
    const [hsTariffcodeCountry, setHsTariffcodeCountry] = useState("");
    const [productId, setProductId] = useState("");
    const [productDescription, setProductDescription] = useState("");
    const [sku, setSku] = useState("");
    const [fda, setFda] = useState("");
    const [currency, setCurrency] = useState("");
    const [productValue, setProductValue] = useState("");
    const [checkedIds, setCheckedIds] = useState([]);
    const [checkedItems, setCheckedItems] = useState([]);
    const [modalImportVisible, setModalImportVisible] = useState(false);
    const [fileUpload, setFileUpload] = useState("")
    const [fileName, setFileName] = useState("")
    const [buttonSubmitDisabled, setButtonSubmitDisabled] = useState(true)
    const [buttonUploadDisabled, setButtonUploadDisabled] = useState(false)
    const [value, setValue] = React.useState(0);
    const [id, setId] = React.useState("");
    const [deleteid, setDeleteId] = React.useState("");
    const [deleteModalopen, setDeleteModalopen] = React.useState(false);
    const [modalTitle, setModalTitle] = useState(value === 1 ? "Items Edit" : "New Items Edit");
    const [originCountryCodeError, setOriginCountryCodeError] = React.useState("");
    const [skuError, setSkuError] = React.useState("");
    const [productDescError, setProductDescError] = React.useState("");
    const [hsTariffcodeError, setHsTariffcodeError] = React.useState("");
    const [hsTariffcodeCountryError, setHsTariffcodeCountryError] = React.useState("");
    const [currencyError, setCurrencyError] = React.useState("");
    const [productValueError, setproductValueError] = React.useState("");
    const [quantity, setQuantity] = useState("");
    const [quantityError, setQuantityError] = React.useState("");
    const [isKit, setIsKit] = React.useState(false);
    const [itemSku, setItemSku] = useState("");
    const [skuInfo, setSkuInfo] = useState([]);
    const [itemSkuError, setItemSkuError] = React.useState("");
    const [skuFilter, setSkuFilter] = React.useState("");
    const [isKitFilter, setIsKitFilter] = React.useState("");
    const [kitItemDetails, setKitItemDetails] = React.useState([]);
    const [kitReady, setKitReady] = useState(false);
    const [kitLoading, setKitLoading] = useState(false);
    let columns = [
        {
            field: 'sku',
            headerName: 'SKU',
            flex: 1
        },
        {
            field: 'product_desc',
            headerName: 'Description',
            flex: 1
        },
        {
            field: 'product_price',
            headerName: 'Product Value',
            flex: 1,
            renderCell: (params) => {
                return <span>{params.row.product_price+" "+params.row.currency}</span>
            }
        },
        {
            field: 'quantity',
            headerName: 'Stock Quantity',
            flex: 1
        },
        {
            field: 'hs_tariff_code',
            headerName: 'Hs Code',
            flex: 1
        },
        {
            field: 'origin_country_code',
            headerName: 'COO',
            flex: 1
        },
        {
            field: "is_kit",
            headerName: "Is Kit",
            width: 100,
            renderCell: (params) => {
                return (
                <div>
                    {params.row.is_kit == true && (
                    <Chip
                        label="Yes"
                        color="success"
                        style={{
                        fontSize: "10px",
                        height: "20px",
                        borderRadius: "5px",
                        }}
                    />
                    )}
                    {!params.row.is_kit && (
                    <Chip
                        label="No"
                        color="error"
                        style={{
                        fontSize: "10px",
                        height: "20px",
                        borderRadius: "5px",
                        }}
                    />
                    )}
                </div>
                );
            },
        },
        {
            field: 'action',
            headerName: 'Action',
            flex: 1,
            renderCell: (params) => {
                return <div>
                    <span style={{ marginRight: '10px' }}>
                        <Tooltip title="Edit" placement="left-start">
                            <IconButton
                                onClick={() => {
                                    setId(params.row.id)
                                    setSelectedItem(params.row);
                                    setModalVisible(true)
                                }}
                            >
                                <EditIcon style={{ color: 'rgba(0,0,0,.54)', cursor: 'pointer' }} />
                            </IconButton>
                        </Tooltip>
                    </span>
                </div>
            }
        },
    ]

    let newColumns = [
        {
            field: 'sku',
            headerName: 'SKU',
            flex: 1
        },
        {
            field: 'product_id',
            headerName: 'ProductId',
            flex: 1
        },
        {
            field: 'product_desc',
            headerName: 'Description',
            flex: 1
        },
        {
            field: 'product_price',
            headerName: 'Product Value',
            flex: 1,
            renderCell: (params) => {
                return <span>{params.row.product_price+" "+params.row.currency}</span>
            }
        },
        {
            field: 'quantity',
            headerName: 'Stock Quantity',
            flex: 1
        },
        {
            field: 'hs_tariff_code',
            headerName: 'Hs Code',
            flex: 1
        },
        {
            field: 'origin_country_code',
            headerName: 'COO',
            flex: 1
        },
        {
            field: "is_kit",
            headerName: "Is Kit",
            width: 100,
            renderCell: (params) => {
                return (
                <div>
                    {params.row.is_kit == true && (
                    <Chip
                        label="Yes"
                        color="success"
                        style={{
                        fontSize: "10px",
                        height: "20px",
                        borderRadius: "5px",
                        }}
                    />
                    )}
                    {!params.row.is_kit && (
                    <Chip
                        label="No"
                        color="error"
                        style={{
                        fontSize: "10px",
                        height: "20px",
                        borderRadius: "5px",
                        }}
                    />
                    )}
                </div>
                );
            },
        },
        {
            field: 'action',
            headerName: 'Action',
            flex: 1,
            renderCell: (params) => {
                return <div>
                    <span style={{ marginRight: '10px' }}>
                        <Tooltip title="Edit" placement="left-start">
                            <IconButton
                                onClick={() => {
                                    setKitReady(false); // ⛔ prevent stale render
                                    setKitLoading(true); // 🔄 show spinner
                                    setId(params.row.id)
                                    setSelectedItem(params.row);
                                    setModalVisible(true)
                                    if(params.row.is_kit){
                                        dispatch(fetchSkuINfo(params.row.sku,"INVENTORY"))
                                    }
                                }}
                            >
                                <EditIcon style={{ color: 'rgba(0,0,0,.54)', cursor: 'pointer' }} />
                            </IconButton>
                        </Tooltip>
                        <span>
                            <Tooltip title="Delete" placement="left-start" disableFocusListener={false}>
                                <IconButton>
                                    <DeleteOutlineOutlinedIcon style={{ color: 'rgba(0,0,0,.54)', cursor: 'pointer' }}
                                        onClick={(e) => {
                                            handleOnClickDelete(params.row.id)
                                        }}
                                    />
                                </IconButton>
                            </Tooltip>
                        </span>
                    </span>
                </div>
            }
        },
    ]

    let kitColumns = [
        {
            field: 'sku',
            headerName: 'SKU',
            flex: 1
        },
        {
            field: 'item_sku',
            headerName: 'Item Sku',
            flex: 1
        },
        {
            field: 'quantity',
            headerName: 'Quantity',
            flex: 1,
        },
        {
            field: 'action',
            headerName: 'Action',
            flex: 1,
            renderCell: (params) => {
                return <div>
                    <span style={{ marginRight: '10px' }}>
                        <Tooltip title="Edit" placement="left-start">
                            <IconButton
                                onClick={() => {
                                    setId(params.row.id)
                                    setSelectedItem(params.row);
                                    setModalVisible(true)
                                   
                                }}
                            >
                                <EditIcon style={{ color: 'rgba(0,0,0,.54)', cursor: 'pointer' }} />
                            </IconButton>
                        </Tooltip>
                        <span>
                            <Tooltip title="Delete" placement="left-start" disableFocusListener={false}>
                                <IconButton>
                                    <DeleteOutlineOutlinedIcon style={{ color: 'rgba(0,0,0,.54)', cursor: 'pointer' }}
                                        onClick={(e) => {
                                            handleOnClickDelete(params.row.id)
                                        }}
                                    />
                                </IconButton>
                            </Tooltip>
                        </span>
                    </span>
                </div>
            }
        },
    ]

    const onSortChange = (currentSorting) => {
        // Only update if there's actually a sort applied, otherwise reset to empty array
        const sortingValue = currentSorting.length > 0 ? JSON.stringify(currentSorting) : "";

        // Check which tab is active and update the corresponding meta
        if (value === 1) {
            setMeta({
                ...meta,
                page: 1, // reset to page 1 on sort
                sorting: sortingValue
            });
        } else if (value === 0) {
            setNewMeta({
                ...newMeta,
                page: 1,
                sorting: sortingValue
            });
        } else {
            setKitMeta({
                ...kitMeta,
                page: 1,
                sorting: sortingValue
            });
        }
    };

    const handleOnClickDelete = (id) => {
        setDeleteId(id)
        setDeleteModalopen(true);
    };

    const deleteModalClose = () => {
        setDeleteModalopen(false);
    };

    const deleteaddress = (id) => {
        dispatch(destoryLineitems(profile && profile.id,id,value))
        setDeleteModalopen(false);
    }

    const validateCurrency = (value) => {
        const regex = /^[A-Za-z]{3}$/; // Only 3 alphabetic characters
        if (!value) {
            return "Currency is required";
        } else if (!regex.test(value)) {
            return "Enter exactly 3 letters (e.g., USD)";
        }
        return "";
    };

    const handleInput = (e) => {
        const value = e.target.value.toUpperCase(); // Optional: auto-uppercase
        setCurrency(value);
        setCurrencyError(""); // Clear error while typing
    };

    const handleBlur = () => {
        const error = validateCurrency(currency);
        setCurrencyError(error);
    };

    const handleHscodeInput = (e) => {
        setHsTariffcode(e.target.value)
        setHsTariffcodeError("")
    };

    const handleHsCodeBlur = () => {
        if(hsTariffcode!=="" && hsTariffcode!==undefined){
            const raw = hsTariffcode.replace(/\D/g, ''); // Remove non-digits
            if (raw.length === 10) {
                const formatted = `${raw.slice(0, 4)}.${raw.slice(4, 6)}.${raw.slice(6, 8)}.${raw.slice(8, 10)}`;
                setHsTariffcode(formatted)
                setHsTariffcodeError("")
            }else{
                setHsTariffcodeError("Hs code must be 10 digits")
            }
        }
    };


    const validateProductValue = (value) => {
        const numericRegex = /^-?\d+(\.\d+)?$/; // Matches integers and decimals
        if (!value) {
            return "Product value is required";
        } else if (!numericRegex.test(value)) {
            return "Only numeric values allowed (e.g., 123 or 123.45)";
        } else if (parseFloat(value) > 5000) {
            return "Product value must not exceed 5000";
        }
        return "";
    };

    const handleProductValueInput = (e) => {
        const value = e.target.value.trim();
        setProductValue(value);
        setproductValueError(""); // Clear error while typing
    };

    const handleProductValueBlur = () => {
        const error = validateProductValue(productValue);
        setproductValueError(error);
    };

    const validateQuantity = (value) => {
        const integerRegex = /^([1-9]\d*|\s*)$/;

        if (!integerRegex.test(value)) {
            return "Only positive integers allowed (e.g., 1, 10, 250)";
        }
        return "";
    };

    const handleQuantityInput = (e) => {
        const value = e.target.value.trim();
        setQuantity(value);
        setQuantityError(""); // Clear error while typing
    };

    const handleQuantityBlur = () => {
        const error = validateQuantity(quantity);
        setQuantityError(error);
    };

    const kitFormRef = useRef();
    const handleSubmit = (e, value,tabValue) => {
        let validatedRows = null;
         // ✅ Only validate kit rows if isKit is true
        if (isKit) {
            validatedRows = kitFormRef.current?.validateAndGetRows();
            if (!validatedRows) {
            console.log('Validation failed in KitDetailsForm');
            return; // Stop submission if kit validation fails
            }
        }
        if(hsTariffcodeError!==""){
            return;
        }
        if (!value.includes('Bulk Edit') && (sku === "" || sku === null || sku === undefined)) {
            setSkuError("Sku is required")
        }else if (tabValue!==2 && !value.includes('Bulk Edit') && (productDescription === "" || productDescription === null || productDescription === undefined)) {
            setProductDescError("Product Description field is required")
        }else if (tabValue!==2 && !isKit && !value.includes('Bulk Edit') && (productValue === "" || productValue === null || productValue === undefined)) {
            setproductValueError("Product value field is required")
        }else if (tabValue!==2 && !isKit && !value.includes('Bulk Edit') && (currency === "" || currency === null || currency === undefined)) {
            setCurrencyError("Currency field is required")
        }else if (tabValue!==2 && !isKit && !value.includes('Bulk Edit') && (hsTariffcode === ""|| hsTariffcode === null || hsTariffcode === undefined)) {
            setHsTariffcodeError("Hstariffcode field is required")
        }else if (tabValue!==2 && !isKit && !originCountryCode) {
            setOriginCountryCodeError("Origin country code Field is required")
        }else if (tabValue===2 && (quantity === ""|| quantity === null || quantity === undefined)) {
            setQuantityError("quantity field is required")
        }else if (tabValue===2 && (itemSku === ""|| itemSku === null || itemSku === undefined)) {
            setItemSkuError("Item sku field is required")
        }else {
            setOriginCountryCodeError("")
            if (value.includes("Items Edit") && tabValue!==2) {
                let finalData={}
                if(isKit){
                    finalData = {
                        "sku": sku,
                        "product_desc": productDescription,
                        "product_price": productValue,
                        "is_kit": isKit,
                        "type": value,
                        "item_details": validatedRows,
                        "id":id
                    }
                }else{
                    finalData = {
                        "product_desc": productDescription,
                        "product_id": productId,
                        "hs_tariff_code": hsTariffcode,
                        "origin_country_code": originCountryCode,
                        "product_price": productValue,
                        "currency": currency,
                        "sku": sku,
                        "quantity": quantity,
                        "type": value,
                        "is_kit": isKit,
                        "id":id
                    }
                }
                console.log(finalData)
                dispatch(updateLineItems(profile && profile.id,id, finalData));
            } else if (value.includes('Bulk Edit') && tabValue!==2) {
                let finalData = {};
                finalData = {
                    "product_desc": productDescription,
                    "hs_tariff_code": hsTariffcode,
                    "origin_country_code": originCountryCode,
                    "product_price": productValue,
                    "product_id": productId,
                    "currency": currency,
                    "skus": checkedIds,
                    "quantity": quantity,
                    "type": value,
                    "is_kit": isKit
                }
                dispatch(updateLineItems(profile && profile.id,1, finalData));
            } else if (value.includes('Add New') && tabValue!==2) {
                if(isKit){
                   let finalData = {
                        "sku": sku,
                        "product_desc": productDescription,
                        "product_price": productValue,
                        "is_kit": isKit,
                        "type": value,
                        "item_details": validatedRows
                    }
                    dispatch(storeNewProduct(profile && profile.id,finalData));
                }else{
                    let finalData = {
                        "product_id": productId,
                        "product_desc": productDescription,
                        "hs_tariff_code": hsTariffcode,
                        "origin_country_code": originCountryCode,
                        "sku": sku,
                        "product_price": productValue,
                        "quantity": quantity,
                        "currency": currency,
                        "is_kit": isKit
                    }
                    dispatch(storeNewProduct(profile && profile.id,finalData));
                }
            }else if (tabValue===2 && value.includes("Items Edit")) {
                let finalData = {
                    "sku": sku,
                    "item_sku": itemSku,
                    "quantity": quantity,
                    "type": value,
                    "tabValue": tabValue,
                    "is_kit":true,
                    "id":id
                }
              dispatch(updateLineItems(profile && profile.id,id, finalData));
            }
        }
    }


    const tabOnClick = (e, value) => {
        setValue(value);
        setCheckedIds([])
        setCheckedItems([])
        setSkuFilter("")
        if (value === 1) {
            setModalTitle("Items Edit")
            setMeta({
                ...meta,
                ...{
                    page: 1,
                }
            });
        } else if (value === 0) {
            setModalTitle("New Items Edit")
            setNewMeta({
                ...newMeta,
                ...{
                    page: 1,
                }
            });
        }else{
            setKitMeta({
                ...kitMeta,
                ...{
                    page: 1,
                }
            });
        }
    };

    const checkBoxCompute = (tempCheckedIds, tempCheckedItems, item, currentSelectedIds) => {
        const index = tempCheckedIds.indexOf(item.sku);
        const method = (currentSelectedIds.indexOf(item.sku) > -1)
        if (method) {
            if (index === -1) {
                tempCheckedIds.push(item.sku);
                tempCheckedItems.push(item)
            }
        } else if (!method) {
            if (index > -1) {
                tempCheckedIds.splice(index, 1);
                tempCheckedItems.splice(index, 1);
            }
        }
        return [tempCheckedIds, tempCheckedItems];
    }
    const onSelectionChange = (currentSelectedIds, currentAllItems) => {
        let tempCheckedIds = [...checkedIds]
        let tempCheckedItems = [...checkedItems];
        currentAllItems.map((item) => (
            checkBoxCompute(tempCheckedIds, tempCheckedItems, item, currentSelectedIds)
        ))
        setCheckedIds(tempCheckedIds)
        setCheckedItems(tempCheckedItems)
    }

    const handleClose = (event, reason) => {
        onModalImportClose();
    }

    const onFileUpload = (e) => {
        e.preventDefault()
        if (e.target.files && e.target.files.length === 0) {
            setFileName(fileUpload.name)
            setFileUpload(fileUpload);
        } else {
            setFileUpload(e.target.files[0]);
            setFileName(e.target.files[0].name)
        }
        setButtonSubmitDisabled(false)
    }

    const onSubmit = () => {
        var formData = new FormData();
        formData.append('file', fileUpload);
        formData.append("tabValue", value);
        dispatch(importProducts(formData))
        setFileName("")
        setFileUpload("")
        setButtonSubmitDisabled(true)
        setButtonUploadDisabled(true)
        setModalImportVisible(false)
    }

    const onModalImportClose = () => {
        setFileName("")
        setFileUpload("")
        setButtonSubmitDisabled(true)
        setButtonUploadDisabled(false)
        setModalImportVisible(false)
    }

    const onModalClose = (event, reason) => {
        if (reason && reason == "backdropClick"){
            return;
        }
        setModalVisible(false)
        setSelectedItem({})
        setOriginCountryCode("")
        setHsTariffcodeCountry("")
        setHsTariffcode("")
        setSku("")
        setFda("")
        setProductDescription("")
        setId("")
        setProductId("")
        setProductValue("")
        setCurrency("")
        setCheckedIds([])
        setCheckedItems([])
        setOriginCountryCodeError("")
        setProductDescError("")
        setSkuError("")
        setHsTariffcodeError("")
        setHsTariffcodeCountryError("")
        setCurrencyError("")
        setproductValueError("")
        setQuantityError("")
        setIsKit(false)
        setItemSkuError("")
        setItemSku("")
        
        if (value === 1) {
            setModalTitle("Items Edit")
        }else if (value === 2) {
            setModalTitle("Items Edit")
        }else {
            setModalTitle("New Items Edit")
        }
    }

    useEffect(() => {
           if(lineitemsnotify && lineitemsnotify.loading==false && lineitemsnotify.notification && lineitemsnotify.notification.messageContent  && lineitemsnotify.notification.messageContent[0] !==''  && lineitemsnotify.notification.messageType!=='error'){
                onModalClose()
           }
    }, [lineitemsnotify]);

    useEffect(() => {
        if (selectedItem && value!==2) {
            setOriginCountryCode(selectedItem.origin_country_code)
            setHsTariffcode(selectedItem.hs_tariff_code)
            setProductId(selectedItem.product_id)
            setProductDescription(selectedItem.product_desc)
            setSku(selectedItem.sku)
            setProductValue(selectedItem.product_price)
            setCurrency(selectedItem.currency)
            setFda(selectedItem.fda)
            setQuantity(selectedItem.quantity)
            setIsKit(selectedItem.is_kit===1 ? true :false)
        }else{
            setSku(selectedItem.sku)
            setQuantity(selectedItem.quantity)
            setItemSku(selectedItem.item_sku)
        }

    }, [selectedItem]);

    const getSelectedCountry = (country_code) => {
        let filteredValue = { code: "", name: "" };
        filteredCountryData.map((key) => {
            if (key.code === country_code) {
                filteredValue = key;
            }
        });
        return filteredValue;
    };

    useEffect(() => {
        if (value === 1) {
            const updatedMeta = {
                ...meta,
                sku: skuFilter
            };
            dispatch(fetchLineItemsData(updatedMeta));
            dispatch(fetchCountry());
        }
    }, [dispatch, meta, value, skuFilter, isKitFilter]);

    useEffect(() => {
        if (value === 0) {
            const updatedMeta = {
                ...newMeta,
                sku: skuFilter,
                is_kit: isKitFilter,
            };
            dispatch(fetchNewLineItemsData(updatedMeta));
            dispatch(fetchCountry());
        }
    }, [dispatch, newMeta, value, skuFilter, isKitFilter]);

    useEffect(() => {
        if (value === 2) {
            const updatedMeta = {
                ...kitMeta,
                sku: skuFilter
            };
            dispatch(fetchKitLineItemsData(updatedMeta));
        }
    }, [dispatch, kitMeta,skuFilter, value]);

    useEffect(() => {
        if (skuInfos?.data?.skuDatas?.length > 0) {
            setKitItemDetails(skuInfos.data.skuDatas);
            setKitReady(true); // ✅ now child can render
            setKitLoading(false); // ✅ hide spinner
        }else{
            setKitItemDetails([]);
            setKitLoading(false);
            setKitReady(true);
        }if (skuInfos?.data?.skuInfos?.length > 0) {
            setSkuInfo(skuInfos.data.skuInfos);
        }
        
    }, [skuInfos]);

    const handleAddNew = () => {
        setKitItemDetails([]);         // ✅ clear previous child data
        setSelectedItem({});         // optional: clear selected SKU
        setKitReady(true);             // ✅ allow child to render immediately
        setModalVisible(true);    
        setKitLoading(false); // ✅ hide spinner     // open modal
    };

    // Legacy logic function wrapper declarations retained intact exactly per specifications
    const onChangePerPage = (event) => { setMeta({ ...meta, page: 1, per_page: event.target.value }); }
    const onChangePagination = (event, page) => { setMeta({ ...meta, page: page }); }
    const onNewChangePerPage = (event) => { setNewMeta({ ...newMeta, page: 1, per_page: event.target.value }); }
    const onNewChangePagination = (event, page) => { console.log(page); setNewMeta({ ...newMeta, page: page }); }
    const onKitChangePerPage = (event) => { setKitMeta({ ...kitMeta, page: 1, per_page: event.target.value }); }
    const onKitChangePagination = (event, page) => { console.log(page); setKitMeta({ ...kitMeta, page: page }); }

    // Dynamic toolbar slot intercept mappings passing parameters straight down to factories
    const CustomToolbar = () => (
        <SharedToolbarFactory 
            activeMeta={meta} 
            dataLength={lineitemsettings?.data?.length} 
            totalCount={lineitemsettings?.meta?.total} 
            onPerPageChange={onChangePerPage} 
        />
    );
    const newCustomToolbar = () => (
        <SharedToolbarFactory 
            activeMeta={newMeta} 
            dataLength={newlineitemsettings?.data?.length} 
            totalCount={newlineitemsettings?.newMeta?.total} 
            onPerPageChange={onNewChangePerPage} 
        />
    );
    const kitCustomToolbar = () => (
        <SharedToolbarFactory 
            activeMeta={kitMeta} 
            dataLength={kitlineitemsettings?.data?.length} 
            totalCount={kitlineitemsettings?.kitMeta?.total} 
            onPerPageChange={onKitChangePerPage} 
        />
    );

    // Dynamic pagination slot intercept mappings passing parameters straight down to factories
    const CustomPagination = () => <SharedPaginationFactory targetMeta={lineitemsettings?.meta} targetCallback={onChangePagination} />;
    const newCustomPagination = () => <SharedPaginationFactory targetMeta={newlineitemsettings?.newMeta} targetCallback={onNewChangePagination} />;
    const kitCustomPagination = () => <SharedPaginationFactory targetMeta={kitlineitemsettings?.kitMeta} targetCallback={onKitChangePagination} />;

    // Unified enterprise DataGrid configuration overrides variable matching premium dashboards
    const enterpriseDataGridStyles = {
        border: 'none',
        backgroundColor: '#FFFFFF',
        overflow: 'hidden',
        '& .MuiDataGrid-topContainer': { backgroundColor: '#F8FAFC', '&::after': { display: 'none' } },
        '& .MuiDataGrid-columnHeaders': { backgroundColor: '#F8FAFC', borderBottom: '1px solid #E2E8F0', minHeight: '52px !important', maxHeight: '52px !important' },
        '& .MuiDataGrid-columnHeader': { color: '#475569', fontWeight: 700, fontSize: '13px', '&:focus, &:focus-within': { outline: 'none' } },
        '& .MuiDataGrid-row': { transition: 'background-color 0.15s ease-in-out', borderBottom: '1px solid #F1F5F9', alignItems: 'center', '&:hover': { backgroundColor: '#F8FAFC' }, '&.Mui-selected': { backgroundColor: 'rgba(25, 118, 210, 0.04)', '&:hover': { backgroundColor: 'rgba(25, 118, 210, 0.08)' } } },
        '& .MuiDataGrid-cell': { fontSize: '13.5px', color: '#334155', borderBottom: 'none', display: 'flex', alignItems: 'center', py: '12px', '&:focus, &:focus-within': { outline: 'none' } },
        '& .MuiCheckbox-root': { color: '#CBD5E1', '&.Mui-checked': { color: '#1976d2' } },
        '& .MuiLinearProgress-root': { height: '3px', backgroundColor: '#E2E8F0', '& .MuiLinearProgress-bar': { backgroundColor: '#1976d2' } }
    };

    return (
        <>
            {(importproduct && importproduct.notification && importproduct.notification.show && importproduct.notification.messageContent) &&
                <Notification
                    is_open={importproduct.notification.show}
                    messageType={importproduct.notification.messageType}
                    messages={importproduct.notification.messageContent}
                    handleClose={() => dispatch(resetLineItemSettingsState())}
                />
            }
            {(lineitemsnotify && lineitemsnotify.notification && lineitemsnotify.notification.show && lineitemsnotify.notification.messageContent) &&
                <Notification
                    is_open={lineitemsnotify.notification.show}
                    messageType={lineitemsnotify.notification.messageType}
                    messages={lineitemsnotify.notification.messageContent}
                    handleClose={() => dispatch(resetLineItemSettingsState())}
                />
            }

            <Modal
                open={deleteModalopen}
                onClose={deleteModalClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                closeAfterTransition
            >
                <Box sx={enterpriseDeleteModalStyle}>
                    
                    {/* Structural Dialog Accent Header Node */}
                    <Typography 
                        id="modal-modal-title" 
                        variant="h6" 
                        component="h2" 
                        sx={{ 
                            fontWeight: 800, 
                            color: '#0F172A', 
                            mb: 1.5, 
                            textAlign: 'center',
                            fontSize: '16px'
                        }}
                    >
                        Confirm Deletion
                    </Typography>

                    {/* Core Narrative Information Context Label */}
                    <Typography 
                        id="modal-modal-description" 
                        variant="body2" 
                        sx={{ 
                            color: '#475569', 
                            fontWeight: 500, 
                            lineHeight: 1.6, 
                            mb: 4, 
                            textAlign: 'center' 
                        }}
                    >
                        Are you sure you want to delete this product? <br /> This action cannot be undone.
                    </Typography>

                    {/* Standardized Inline Action Layout Footer Panel */}
                    <Box 
                        sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center', 
                            gap: 1.5,
                            width: '100%'
                        }}
                    >
                        {/* Cancel Trigger Command Button */}
                        <Button
                            variant="outlined"
                            onClick={deleteModalClose}
                            sx={{
                                textTransform: 'none',
                                borderRadius: '10px',
                                fontWeight: 700,
                                fontSize: '13.5px',
                                height: '38px',
                                px: 3.5,
                                borderColor: '#E2E8F0',
                                color: '#475569',
                                transition: 'all 0.15s ease-in-out',
                                '&:hover': {
                                    borderColor: '#CBD5E1',
                                    backgroundColor: '#F8FAFC',
                                    color: '#1E293B'
                                }
                            }}
                        >
                            No, Cancel
                        </Button>

                        {/* Confirm Database Call Execution Commit Trigger Button */}
                        <Button
                            variant="contained"
                            onClick={(event) => {
                                deleteaddress(deleteid);
                            }}
                            sx={{
                                textTransform: 'none',
                                borderRadius: '10px',
                                fontWeight: 700,
                                fontSize: '13.5px',
                                height: '38px',
                                px: 4.5,
                                boxShadow: 'none',
                                backgroundColor: '#1976d2', // --- CORPORATE THEME SYSTEM ACCENT BLUE ---
                                color: '#FFFFFF',
                                transition: 'all 0.15s ease-in-out',
                                '&:hover': {
                                    backgroundColor: '#115293',
                                    boxShadow: 'none'
                                }
                            }}
                        >
                            Yes, Delete
                        </Button>
                    </Box>

                </Box>
            </Modal>

            <Modal
                open={modalImportVisible}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                closeAfterTransition
            >
                <Box sx={enterpriseImportModalStyle}>
                    <Card 
                        className="sc--cardhead--details"
                        sx={{ 
                            backgroundColor: '#FFFFFF',
                            borderRadius: '16px',
                            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                            border: '1px solid #E2E8F0',
                            overflow: 'hidden'
                        }}
                    >
                        {/* Modal Layout Header Segment Block */}
                        <CardHeader 
                            title={
                                <Typography variant="h6" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '16px' }}>
                                    Import New Products
                                </Typography>
                            } 
                            action={
                                <IconButton 
                                    aria-label="settings" 
                                    onClick={onModalImportClose}
                                    sx={{ 
                                        color: '#64748B',
                                        '&:hover': { backgroundColor: '#F1F5F9', color: '#1E293B' }
                                    }}
                                >
                                    <CloseIcon sx={{ fontSize: '20px' }} />
                                </IconButton>
                            }
                            sx={{ p: 2.5, backgroundColor: '#FFFFFF' }}
                        />
                        
                        {/* Asynchronous Loading Progression Layout Tracker Line */}
                        {importproduct && importproduct.loading === true &&
                            <LinearProgress sx={{ height: '3px', backgroundColor: '#E2E8F0', '& .MuiLinearProgress-bar': { backgroundColor: '#1976d2' } }} />
                        }
                        
                        <Divider sx={{ borderColor: '#E2E8F0' }} />
                        
                        <CardContent sx={{ p: 3 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
                                
                                {/* Interactive Premium File Picker Zone Layer */}
                                <label htmlFor="contained-button-file" style={{ width: '100%', cursor: 'pointer' }}>
                                    <Input 
                                        accept=".csv" 
                                        id="contained-button-file" 
                                        onChange={onFileUpload} 
                                        key={fileName} 
                                        name='import_recipient_address_book' 
                                        multiple 
                                        type="file" 
                                    />
                                    
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            p: 4,
                                            backgroundColor: '#F8FAFC',
                                            border: '2px dashed #CBD5E1',
                                            borderRadius: '12px',
                                            transition: 'all 0.2s ease-in-out',
                                            textAlign: 'center',
                                            '&:hover': {
                                                backgroundColor: '#F1F5F9',
                                                borderColor: '#1976d2'
                                            }
                                        }}
                                    >
                                        <CloudUploadOutlinedIcon sx={{ fontSize: '40px', color: '#64748B', mb: 1.5 }} />
                                        
                                        <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#334155', mb: 0.5 }}>
                                            Click here to choose your product CSV file
                                        </Typography>
                                        <Typography sx={{ fontSize: '12px', color: '#94A3B8', mb: 2.5 }}>
                                            Supports standard .csv file matrices
                                        </Typography>

                                        <Button 
                                            variant="contained" 
                                            component="span" 
                                            disabled={buttonUploadDisabled}
                                            sx={{
                                                textTransform: 'none',
                                                borderRadius: '10px',
                                                fontWeight: 700,
                                                fontSize: '13px',
                                                height: '36px',
                                                px: 3,
                                                boxShadow: 'none',
                                                backgroundColor: '#1976d2', // --- CORPORATE IDENTITY BRAND ACCENT ---
                                                color: '#FFFFFF',
                                                '&:hover': { backgroundColor: '#115293', boxShadow: 'none' },
                                                '&.Mui-disabled': { backgroundColor: '#E2E8F0', color: '#94A3B8' }
                                            }}
                                        >
                                            Select File
                                        </Button>
                                    </Box>
                                </label>

                                {/* File Meta Tracking Info Banner Component Panel */}
                                {fileName && (
                                    <Box 
                                        sx={{ 
                                            display: 'flex', 
                                            alignItems: 'center', 
                                            gap: 1, 
                                            mt: 2, 
                                            p: 1.2, 
                                            width: '100%', 
                                            boxSizing: 'border-box',
                                            backgroundColor: 'rgba(25, 118, 210, 0.04)', 
                                            border: '1px dashed rgba(25, 118, 210, 0.2)', 
                                            borderRadius: '8px' 
                                        }}
                                    >
                                        <AttachFileIcon sx={{ fontSize: '16px', color: '#1976d2' }} />
                                        <Typography sx={{ fontSize: '12px', fontWeight: 600, color: '#1E293B', wordBreak: 'break-all' }}>
                                            Selected file: <span style={{ color: '#1976d2' }}>{fileName}</span>
                                        </Typography>
                                    </Box>
                                )}

                                {/* Contextual Data Blueprint Resource References Sheet Links Anchor */}
                                <Box sx={{ mt: 3, textAlign: 'center' }}>
                                    {value !== 2 && (
                                        <Typography
                                            component="a"
                                            href="https://shippingchimp.s3.us-east-2.amazonaws.com/labelgen/sample/PRODUCTS_DATA_SAMPLE.csv"
                                            sx={{
                                                fontSize: '13px',
                                                fontWeight: 600,
                                                color: '#1976d2',
                                                textDecoration: 'none',
                                                '&:hover': { textDecoration: 'underline', color: '#115293' }
                                            }}
                                        >
                                            Download Sample New Products CSV
                                        </Typography>
                                    )}
                                    {value === 2 && (
                                        <Typography
                                            component="a"
                                            href="https://shippingchimp.s3.us-east-2.amazonaws.com/labelgen/sample/PRODUCTS_KIT_DETAILS_SAMPLE.csv"
                                            sx={{
                                                fontSize: '13px',
                                                fontWeight: 600,
                                                color: '#1976d2',
                                                textDecoration: 'none',
                                                '&:hover': { textDecoration: 'underline', color: '#115293' }
                                            }}
                                        >
                                            Download Sample New Products CSV
                                        </Typography>
                                    )}
                                </Box>

                                <Divider sx={{ width: '100%', my: 3, borderColor: '#F1F5F9' }} />

                                {/* Process Submission Commit Button Core Actions Panel Wrapper */}
                                <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                                    <Button 
                                        variant="contained" 
                                        onClick={onSubmit} 
                                        disabled={buttonSubmitDisabled}
                                        sx={{
                                            textTransform: 'none',
                                            borderRadius: '10px',
                                            fontWeight: 700,
                                            fontSize: '13.5px',
                                            height: '38px',
                                            px: 4,
                                            boxShadow: 'none',
                                            backgroundColor: '#1976d2',
                                            color: '#FFFFFF',
                                            '&:hover': { backgroundColor: '#115293', boxShadow: 'none' },
                                            '&.Mui-disabled': { backgroundColor: '#E2E8F0', color: '#94A3B8' }
                                        }}
                                    >
                                        Submit Product Data
                                    </Button>
                                </Box>

                            </Box>
                        </CardContent>
                    </Card>
                </Box>
            </Modal>
            <Modal
                open={modalVisible}
                onClose={onModalClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                closeAfterTransition
            >
                <Box sx={enterpriseModalWrapperStyle}>
                    <Card 
                        className="sc--cardhead--details"
                        sx={{ 
                            backgroundColor: '#FFFFFF',
                            borderRadius: '16px',
                            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                            border: '1px solid #E2E8F0',
                            overflow: 'hidden',
                            display: 'flex',
                            flexDirection: 'column'
                        }}
                    >
                        {/* Modal Workspace Header Module */}
                        <CardHeader 
                            title={
                                <Typography variant="h6" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '16px' }}>
                                    {modalTitle}
                                </Typography>
                            }  
                            action={
                                <IconButton 
                                    aria-label="settings" 
                                    onClick={onModalClose}
                                    sx={{ 
                                        color: '#64748B',
                                        '&:hover': { backgroundColor: '#F1F5F9', color: '#1E293B' }
                                    }}
                                >
                                    <CloseIcon sx={{ fontSize: '20px' }} />
                                </IconButton>
                            }
                            sx={{ p: 2.5, backgroundColor: '#FFFFFF' }}
                        />
                        
                        <Divider sx={{ borderColor: '#E2E8F0' }} />
                        
                        <CardContent
                            sx={{
                                p: 0,
                                '&:last-child': { paddingBottom: '0px !important' }, // Absolute container layout allocation
                                display: 'flex',
                                flexDirection: 'column',
                                overflow: 'hidden'
                            }}
                        >
                            {/* Fluid Inner Scrolling Forms Canvas Layer */}
                            <Box
                                sx={{
                                    p: 3,
                                    overflowY: 'auto',
                                    width: '100%',
                                    boxSizing: 'border-box',
                                    ...(value !== 2 && {
                                        maxHeight: 'calc(65vh - 60px)'
                                    })
                                }}
                            >
                                <Grid container spacing={2.5}>
                                    
                                    {/* --- ROW 1 SECTION: PRODUCT BASE ENTITY CONFIGURATOR METRICS --- */}
                                    {(value !== 2 && modalTitle !== 'Bulk Edit' && modalTitle !== 'New Products Bulk Edit') && (
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth variant="outlined" className="help-text-error" sx={enterpriseModalInputStyles}>
                                                <InputLabel id="demo-simple-select-standard-label">Is Kit*</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-standard-label"
                                                    id="demo-simple-select-error"
                                                    name="isKit"
                                                    defaultValue={isKit}
                                                    label="Is Kit*"
                                                    onChange={e => {
                                                        dispatch(fetchSkuINfo("", "INVENTORY"))
                                                        setIsKit(e.target.value)
                                                    }}
                                                    disabled={modalTitle === 'Items Edit' || modalTitle === 'New Items Edit'} // ✅ added condition
                                                >
                                                    <MenuItem value={false}>False</MenuItem>
                                                    <MenuItem value={true}>True</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    )}
                                    
                                    {(modalTitle !== 'Bulk Edit' && modalTitle !== 'New Products Bulk Edit') && (
                                        <Grid item xs={12} sm={(value !== 2) ? 6 : 12}>
                                            <TextField
                                                id="outlined-read-only-input"
                                                label="Sku"
                                                name="sku"
                                                fullWidth
                                                size="small"
                                                defaultValue={sku}
                                                onInput={e => {
                                                    setSku(e.target.value)
                                                    setSkuError("")
                                                }}
                                                InputProps={{ readOnly: (modalTitle === 'Items Edit' || modalTitle === 'New Items Edit') ? true : false }}
                                                variant={(modalTitle === 'Items Edit' || modalTitle === 'New Items Edit') ? "filled" : "outlined"}
                                                error={!!skuError}
                                                helperText={skuError}
                                                sx={enterpriseModalInputStyles}
                                            />
                                        </Grid>
                                    )}

                                    {/* --- ROW 2 SECTION: INTERACTIVE LINE ITEM DATA BLUEPRINTS --- */}
                                    {(value !== 2 && modalTitle !== 'Bulk Edit' && modalTitle !== 'New Products Bulk Edit') && (
                                        <>
                                            <Grid item xs={12} sm={4}>
                                                <TextField
                                                    label="Product Id"
                                                    name="product_id"
                                                    fullWidth
                                                    size="small"
                                                    defaultValue={productId}
                                                    onInput={e => {
                                                        setProductId(e.target.value)
                                                    }}
                                                    variant="outlined"
                                                    sx={enterpriseModalInputStyles}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <TextField
                                                    label="Product Value"
                                                    name="product value"
                                                    fullWidth
                                                    size="small"
                                                    defaultValue={productValue}
                                                    onInput={handleProductValueInput}
                                                    onBlur={handleProductValueBlur}
                                                    variant="outlined"
                                                    error={!!productValueError}
                                                    helperText={productValueError}
                                                    sx={enterpriseModalInputStyles}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <TextField
                                                    label="Product Description"
                                                    name="product_description"
                                                    fullWidth
                                                    size="small"
                                                    defaultValue={productDescription}
                                                    onInput={e => {
                                                        setProductDescription(e.target.value)
                                                        setProductDescError("")
                                                    }}
                                                    variant="outlined"
                                                    error={!!productDescError}
                                                    helperText={productDescError}
                                                    sx={enterpriseModalInputStyles}
                                                />
                                            </Grid>
                                        </>
                                    )}

                                    {/* --- ROW 3 SECTION: COMPLEX INVENTORY COMPONENT CHANNELS LINK DATA --- */}
                                    {value === 2 && (
                                        <>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    label="Item Sku"
                                                    name="item_sku"
                                                    fullWidth
                                                    size="small"
                                                    defaultValue={itemSku}
                                                    InputProps={{ readOnly: (modalTitle === 'Items Edit' || modalTitle === 'New Items Edit') ? true : false }}
                                                    onInput={e => {
                                                        setItemSku(e.target.value)
                                                        setItemSkuError("")
                                                    }}
                                                    variant={(modalTitle === 'Items Edit' || modalTitle === 'New Items Edit') ? "filled" : "outlined"}
                                                    error={!!itemSkuError}
                                                    helperText={itemSkuError}
                                                    sx={enterpriseModalInputStyles}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    label="Quantity"
                                                    name="quantity"
                                                    fullWidth
                                                    size="small"
                                                    defaultValue={quantity}
                                                    onInput={handleQuantityInput}
                                                    InputProps={{ readOnly: (isKit && (modalTitle === 'Items Edit' || modalTitle === 'New Items Edit')) ? true : false }}
                                                    onBlur={handleQuantityBlur}
                                                    variant={(isKit && (modalTitle === 'Items Edit' || modalTitle === 'New Items Edit')) ? "filled" : "outlined"}
                                                    error={!!quantityError}
                                                    helperText={quantityError}
                                                    sx={enterpriseModalInputStyles}
                                                />
                                            </Grid>
                                        </>
                                    )}

                                    {/* --- ROW 4 SECTION: PRICING LOGISTICS AUDIT TRACE SHEETS --- */}
                                    <>
                                        {(!isKit && value !== 2 && modalTitle !== 'Bulk Edit' && modalTitle !== 'New Products Bulk Edit') && (
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    label="Stock Quantity"
                                                    name="quantity"
                                                    fullWidth
                                                    size="small"
                                                    defaultValue={quantity}
                                                    onInput={handleQuantityInput}
                                                    InputProps={{ readOnly: (isKit && (modalTitle === 'Items Edit' || modalTitle === 'New Items Edit')) ? true : false }}
                                                    onBlur={handleQuantityBlur}
                                                    variant={(isKit && (modalTitle === 'Items Edit' || modalTitle === 'New Items Edit')) ? "filled" : "outlined"}
                                                    error={!!quantityError}
                                                    helperText={quantityError}
                                                    sx={enterpriseModalInputStyles}
                                                />
                                            </Grid>
                                        )}
                                        {(!isKit && value !== 2) && (
                                            <Grid item xs={12} sm={(!isKit && value !== 2 && modalTitle !== 'Bulk Edit' && modalTitle !== 'New Products Bulk Edit') ? 6 : 12}>
                                                <TextField
                                                    label="Currency"
                                                    name="currency"
                                                    fullWidth
                                                    size="small"
                                                    defaultValue={currency}
                                                    onInput={handleInput}
                                                    onBlur={handleBlur}
                                                    variant="outlined"
                                                    error={!!currencyError}
                                                    helperText={currencyError}
                                                    sx={enterpriseModalInputStyles}
                                                />
                                            </Grid>
                                        )}
                                    </>

                                    {/* --- ROW 5 SECTION: CROSSBORDER INTERNATIONAL COMPLIANCE ARCHIVES --- */}
                                    <>
                                        {(value !== 2 && !isKit) && (
                                            <Grid item xs={12} sm={(!isKit && value !== 2 && modalTitle !== 'Bulk Edit' && modalTitle !== 'New Products Bulk Edit') ? 6 : 12}>
                                                <Autocomplete
                                                    className="help-text-error"
                                                    disablePortal
                                                    name="origin_country_code"
                                                    id="country-select-demo"
                                                    options={filteredCountryData}
                                                    autoHighlight
                                                    loading={country_code && country_code.loading}
                                                    getOptionLabel={(option) => option.name}
                                                    value={getSelectedCountry(originCountryCode)}
                                                    renderOption={(props, option) => (
                                                        <MenuItem {...props} value={option.code} key={option.code} sx={{ fontSize: '13.5px' }}>
                                                            {option.icon} {option.name}
                                                        </MenuItem>
                                                    )}
                                                    onChange={(event, value) => {
                                                        if (value !== null) {
                                                            setOriginCountryCode(value.code);
                                                            setOriginCountryCodeError("")
                                                        } else {
                                                            setOriginCountryCode("");
                                                        }
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Country of Origin"
                                                            variant="outlined"
                                                            size="small"
                                                            error={!!originCountryCodeError}
                                                            helperText={originCountryCodeError}
                                                            sx={enterpriseModalInputStyles}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        )}
                                        {(!isKit && value !== 2 && modalTitle !== 'Bulk Edit' && modalTitle !== 'New Products Bulk Edit') && (
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    label="Hs Code"
                                                    name="tag_name"
                                                    fullWidth
                                                    size="small"
                                                    defaultValue={hsTariffcode}
                                                    onInput={handleHscodeInput}
                                                    onBlur={handleHsCodeBlur}
                                                    variant="outlined"
                                                    error={!!hsTariffcodeError}
                                                    helperText={hsTariffcodeError}
                                                    sx={enterpriseModalInputStyles}
                                                />
                                            </Grid>
                                        )}
                                    </>

                                    {/* --- KIT ASSEMBLY DATA MANAGEMENT COMPONENT PORTAL --- */}
                                    {isKit && modalVisible && (
                                        <Grid item xs={12}>
                                            {kitLoading && (
                                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContext: 'center', p: 4, gap: 1.5 }}>
                                                    <CircularProgress size={32} sx={{ color: '#1976d2' }} />
                                                    <Typography sx={{ fontSize: '13.5px', fontWeight: 600, color: '#64748B' }}>
                                                        Loading kit details…
                                                    </Typography>
                                                </Box>
                                            )}
                                            {!kitLoading && kitReady && (
                                                <Box sx={{ mt: 1, border: '1px solid #E2E8F0',padding:'10px', borderRadius: '12px', overflow: 'hidden' }}>
                                                    <KitDetailsForm
                                                        ref={kitFormRef}
                                                        modalTitle={modalTitle}
                                                        isKit={selectedItem?.is_kit}
                                                        initialRows={kitItemDetails}
                                                        skuOnly={skuInfo}
                                                    />
                                                </Box>
                                            )}
                                        </Grid>
                                    )}

                                </Grid>
                            </Box>

                            {/* --- CARD FOOTER MODULE: CONTEXT STICKY EXECUTION CONTROL ACTIONS BAR --- */}
                            <Box
                                sx={{
                                    position: 'sticky',
                                    bottom: 0,
                                    backgroundColor: '#F8FAFC',
                                    px: 3,
                                    py: 2,
                                    borderTop: '1px solid #E2E8F0',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-end',
                                    zIndex: 10,
                                    width: '100%',
                                    boxSizing: 'border-box'
                                }}
                            >
                                <Button 
                                    variant="contained" 
                                    onClick={e => handleSubmit(e, modalTitle, value)}
                                    sx={{
                                        textTransform: 'none',
                                        borderRadius: '10px',
                                        fontWeight: 700,
                                        fontSize: '13.5px',
                                        height: '38px',
                                        px: 4,
                                        boxShadow: 'none',
                                        backgroundColor: '#1976d2',
                                        color: '#FFFFFF',
                                        transition: 'all 0.15s ease-in-out',
                                        '&:hover': { 
                                            backgroundColor: '#115293',
                                            boxShadow: 'none',
                                            transform: 'translateY(-1px)' 
                                        },
                                        '&:active': {
                                            transform: 'translateY(0)'
                                        }
                                    }}
                                >
                                    Submit Data
                                </Button>
                            </Box>
                            
                        </CardContent>
                    </Card>
                </Box>
            </Modal>
            <Card 
                className="sc--cardhead--details"
                sx={{ 
                    width: '100%', 
                    backgroundColor: '#FFFFFF',
                    border: '1px solid #E2E8F0',
                    borderRadius: '16px',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.02)',
                    overflow: 'hidden'
                }}
            >
                {/* Workspace Utility Control Header Layer */}
                <CardHeader
                    title={
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', flexWrap: 'wrap', gap: 2 }}>
                            <Typography variant="h5" component="h1" sx={{ fontWeight: 800, color: '#0F172A', letterSpacing: '-0.5px' }}>
                                Inventory
                            </Typography>

                            {/* Centered Structural Filters Block Area */}
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexGrow: 1, justifyContent: 'center', flexWrap: 'wrap' }}>
                                <TextField
                                    placeholder="Search SKU..."
                                    value={skuFilter}
                                    onChange={(e) => setSkuFilter(e.target.value)}
                                    size="small"
                                    variant="outlined"
                                    sx={{ minWidth: 200, ...enterpriseControlStyles }}
                                />

                                {value === 0 && (
                                    <FormControl size="small" variant="outlined" sx={{ minWidth: 140, ...enterpriseControlStyles }}>
                                        <InputLabel id="is-kit-label">Is Kit*</InputLabel>
                                        <Select
                                            labelId="is-kit-label"
                                            id="is-kit-select"
                                            name="isKit"
                                            value={isKitFilter}
                                            label="Is Kit*"
                                            onChange={e => setIsKitFilter(e.target.value)}
                                        >   
                                            <MenuItem value={""}>All</MenuItem>
                                            <MenuItem value={false}>False</MenuItem>
                                            <MenuItem value={true}>True</MenuItem>
                                        </Select>
                                    </FormControl>
                                )}
                            </Box>

                            {/* Right-Aligned Conditional Command Controls Trigger Action Button */}
                            <Box sx={{ minWidth: 100, display: 'flex', justifyContent: 'flex-end' }}>
                                {(checkedIds && checkedIds.length >= 1) && (
                                    <Button
                                        variant="contained"
                                        onClick={() => {
                                            setModalVisible(true);
                                            setModalTitle(value === 1 ? "Bulk Edit" : "New Products Bulk Edit");
                                        }}
                                        sx={{
                                            textTransform: 'none',
                                            borderRadius: '10px',
                                            fontWeight: 700,
                                            fontSize: '13.5px',
                                            height: '38px',
                                            boxShadow: 'none',
                                            backgroundColor: '#1976d2',
                                            color: '#FFFFFF',
                                            '&:hover': { backgroundColor: '#115293', boxShadow: 'none' }
                                        }}
                                    >
                                        Bulk Edit
                                    </Button>
                                )}
                            </Box>
                        </Box>
                    }
                    sx={{ p: 2.5, borderBottom: '1px solid #E2E8F0', backgroundColor: '#FFFFFF' }}
                />

                <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
                    <Box className="scmaincard" sx={{ width: '100%' }}>
                        
                        {/* Modern Operational Workflow Segment Navigation Tab Bar Wrapper */}
                        <Box 
                            className="deliveries_tab" 
                            sx={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'space-between', 
                                px: 2.5, 
                                py: 1,
                                backgroundColor: '#F8FAFC', 
                                borderBottom: '1px solid #E2E8F0' 
                            }}
                        >
                            <Tabs 
                                value={value} 
                                onChange={tabOnClick} 
                                aria-label="basic tabs example"
                                sx={{
                                    minHeight: '44px',
                                    '& .MuiTabs-indicator': { height: '3px', borderRadius: '3px', backgroundColor: '#1976d2' },
                                    '& .MuiTab-root': {
                                        textTransform: 'none',
                                        fontSize: '13.5px',
                                        fontWeight: 600,
                                        color: '#64748B',
                                        minHeight: '44px',
                                        '&.Mui-focused, &.Mui-selected': { color: '#1976d2', fontWeight: 700 }
                                    }
                                }}
                            >
                                <Tab label="Complete" />
                                <Tab label="Missing" />
                                <Tab label="Kit Details" />
                            </Tabs>

                            {(value === 0) && (
                                <Stack direction="row" spacing={1.5} alignItems="center">
                                    <Button 
                                        variant="contained" 
                                        onClick={() => {
                                            handleAddNew()
                                            setModalVisible(true)
                                            setModalTitle("Add New")
                                        }}
                                        sx={{
                                            textTransform: 'none',
                                            borderRadius: '10px',
                                            fontWeight: 700,
                                            fontSize: '13px',
                                            height: '34px',
                                            px: 2.5,
                                            boxShadow: 'none',
                                            backgroundColor: '#1976d2',
                                            color: '#FFFFFF',
                                            '&:hover': { backgroundColor: '#115293', boxShadow: 'none' }
                                        }}
                                    >
                                        Add New
                                    </Button>
                                    <Tooltip title="Import" placement="top">
                                        <IconButton 
                                            onClick={() => { 
                                                setModalImportVisible(true) 
                                                setButtonUploadDisabled(false)
                                            }}
                                            sx={{
                                                color: '#1976d2',
                                                padding: '7px',
                                                borderRadius: '8px',
                                                border: '1px solid #E2E8F0',
                                                backgroundColor: '#FFFFFF',
                                                '&:hover': { backgroundColor: '#F1F5F9', borderColor: '#CBD5E1' }
                                            }}
                                        >
                                            <UploadIcon sx={{ fontSize: '18px' }} />
                                        </IconButton>
                                    </Tooltip>
                                </Stack>
                            )}
                        </Box>

                        {/* --- SELECTION VIEW OVERLAY PORTAL WINDOW A: RAW COMPLETE DATA MATRIX --- */}
                        {value === 1 && (
                            <Box sx={{ width: '100%', backgroundColor: '#FFFFFF' }}>
                                <DataGrid
                                    sx={enterpriseDataGridStyles}
                                    getRowId={(row) => row.sku}
                                    rows={lineitemsettings && lineitemsettings.data}
                                    columns={columns}
                                    autoHeight={true}
                                    disableColumnFilter={true}
                                    disableColumnMenu={true}
                                    checkboxSelection
                                    onRowSelectionModelChange={(newSelectionModel) => { onSelectionChange(newSelectionModel, lineitemsettings.data) }}
                                    rowSelectionModel={checkedIds}
                                    disableRowSelectionOnClick
                                    slots={{
                                        loadingOverlay: LinearProgress,
                                        footer: CustomPagination,
                                        toolbar: CustomToolbar,
                                        NorowsData
                                    }}
                                    loading={
                                        ((lineitemsettings && lineitemsettings.loading) ||
                                            (lineitemsnotify && lineitemsnotify.loading) ||
                                            (importproduct && importproduct.loading)
                                        )
                                    }
                                />
                            </Box>
                        )}

                        {/* --- SELECTION VIEW OVERLAY PORTAL WINDOW B: MISSING PIPELINES GRID MATRIX --- */}
                        {value === 0 && (
                            <Box sx={{ width: '100%', backgroundColor: '#FFFFFF' }}>
                                <DataGrid
                                    sx={enterpriseDataGridStyles}
                                    getRowId={(row) => row.sku}
                                    rows={newlineitemsettings && newlineitemsettings.data}
                                    columns={newColumns}
                                    autoHeight={true}
                                    disableColumnFilter={true}
                                    disableColumnMenu={true}
                                    checkboxSelection
                                    onRowSelectionModelChange={(newSelectionModel) => { onSelectionChange(newSelectionModel, newlineitemsettings.data) }}
                                    rowSelectionModel={checkedIds}
                                    isRowSelectable={(params) => !params.row.is_kit}
                                    disableRowSelectionOnClick
                                    sortingMode="server"
                                    sortingOrder={['asc', 'desc']}
                                    onSortModelChange={onSortChange}
                                    sortModel={
                                        (value === 1 ? meta.sorting : (value === 0 ? newMeta.sorting : kitMeta.sorting)) 
                                        ? JSON.parse(value === 1 ? meta.sorting : (value === 0 ? newMeta.sorting : kitMeta.sorting)) 
                                        : []
                                    }
                                    slots={{
                                        loadingOverlay: LinearProgress,
                                        footer: newCustomPagination,
                                        toolbar: newCustomToolbar,
                                        NorowsData
                                    }}
                                    loading={
                                        ((newlineitemsettings && newlineitemsettings.loading) ||
                                            (lineitemsnotify && lineitemsnotify.loading) ||
                                            (importproduct && importproduct.loading)
                                        )
                                    }
                                />
                            </Box>
                        )}

                        {/* --- SELECTION VIEW OVERLAY PORTAL WINDOW C: ASSEMBLY KIT PARTS ARCHIVES --- */}
                        {value === 2 && (
                            <Box sx={{ width: '100%', backgroundColor: '#FFFFFF' }}>
                                <DataGrid
                                    sx={enterpriseDataGridStyles}
                                    getRowId={(row) => row.id}
                                    rows={kitlineitemsettings && kitlineitemsettings.data}
                                    columns={kitColumns}
                                    autoHeight={true}
                                    disableColumnFilter={true}
                                    disableColumnMenu={true}
                                    disableRowSelectionOnClick
                                    sortingMode="server" 
                                    sortingOrder={['asc', 'desc']}
                                    onSortModelChange={onSortChange} 
                                    sortModel={kitMeta.sorting ? JSON.parse(kitMeta.sorting) : []}
                                    slots={{
                                        loadingOverlay: LinearProgress,
                                        footer: kitCustomPagination,
                                        toolbar: kitCustomToolbar,
                                        NorowsData
                                    }}
                                    loading={
                                        ((kitlineitemsettings && kitlineitemsettings.loading) ||
                                            (lineitemsnotify && lineitemsnotify.loading) ||
                                            (importproduct && importproduct.loading)
                                        )
                                    }
                                />
                            </Box>
                        )}

                    </Box>
                </CardContent>
            </Card>

        </>
    )
}

export default ProductLineItemsPage;
